export { default } from './HeaderEmbedSim';
